import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PollDetailSchema } from './shapes';

export const getPoll = defineEndpoint({
  method: 'GET',
  path: '/v1/polls/:pollId',
  params: z.object({ pollId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: PollDetailSchema }),
});
